jQuery(document).ready(function(){

 setTimeout(function() {
 if (window.innerWidth <= 768) { // Apply only if screen width is 768px or less
        $(".wrap-content p").each(function () {
            var fullText = $(this).html();
            var truncatedText = fullText.substring(0, 100); // Show only first 100 characters

            if (fullText.length > 100) {
                $(this).html(truncatedText + '... <a href="#" class="read-more">Read More</a>');
            }

            $(this).on("click", ".read-more", function (e) {
                e.preventDefault();
                $(this).parent().html(fullText + ' <a href="#" class="read-less">Read Less</a>');
            });

            $(this).on("click", ".read-less", function (e) {
                e.preventDefault();
                $(this).parent().html(truncatedText + '... <a href="#" class="read-more">Read More</a>');
            });
        });
    }
      }, 1500);

$('.collection-toolbar__button').on('click', function () {
        // Toggle active class on buttons
        $('.collection-toolbar__button').removeClass('active');
        $(this).addClass('active');

        // Get selected view type
        var viewType = $(this).val();

        // Toggle class on UL to switch layout
        var productList = $('.product-grid'); // Adjust selector as needed
        
        if (viewType === 'large') {
            productList.removeClass('list-view').addClass('grid-view');
        } else {
            productList.removeClass('grid-view').addClass('list-view');
        }
    });

   // setTimeout(function () {
    jQuery.getJSON('/cart.js', function (cart) {
      console.log(cart.item_count);
      jQuery('#cart-count').text(cart.item_count);
    });
  // }, 20); // Slight delay ensures cart is updated before fetching

jQuery(window).on('load', function(){
  jQuery('.slick-slider').slick({
    slidesToShow: 4.5,
    slidesToScroll: 1,       // Use 1 for a smoother, continuous effect
    autoplay: true,
    autoplaySpeed: 0,
    speed: 14000,
    cssEase: 'linear',
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});

    // Create an Intersection Observer to detect when the slider is in view
  // let observer = new IntersectionObserver(function(entries) {
  //   // Check if the slider element is in view
  //   if(entries[0].isIntersecting){
  //     // Start autoplay once it becomes visible
  //     $('.slick-slider').slick('slickPlay');
  //     // Optional: Unobserve after starting the slider to prevent repeated triggers
  //     observer.unobserve(entries[0].target);
  //   }
  // }, { threshold: 0.1 }); // Adjust threshold as needed

  // // Start observing the slider element
  // observer.observe(document.querySelector('.slick-slider'));








  

  jQuery('.inner-slide-testimonial').slick({
    slidesToShow: 2,
  slidesToScroll: 2,
      arrows: true,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0852/8930/4392/files/left-icon.png?v=1740564907'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0852/8930/4392/files/right-icon.png?v=1740564908'>",
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
  });

  jQuery(document).on('click', 'form[action="/cart/add"] [type="submit"]', function (e) {
  setTimeout(function () {
    jQuery.getJSON('/cart.js', function (cart) {
      console.log(cart.item_count);
      jQuery('#cart-count').text(cart.item_count);
    });
  }, 500); // Slight delay ensures cart is updated before fetching
});
  

  
jQuery(window).on('scroll', function() {
  var $triggerSection = jQuery('.footer'); // This section's position is being checked
  var $targetSection = jQuery('.fixed_image');   // This section will have the class added or removed

  if ($triggerSection.offset().top - $(window).scrollTop() <= 800) {
    $targetSection.addClass('hidden');  // Add the class to the target section
  } else {
    $targetSection.removeClass('hidden');  // Remove the class from the target section
  }
});

$('.extra-class .slick-slider').slick({
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
   asNavFor: '.slider-nav',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '5%'
                }
            },
           {
            breakpoint: 480, // Mobile devices
            settings: {
                slidesToShow: 1,
                centerPadding: '0%', // Remove padding for better fit on small screens
                arrows: false // Hide arrows to save space
            }
        }
        ]
});

  $('.slider-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.extra-class .slick-slider',
  dots: true,
  centerMode: true,
  focusOnSelect: true
});


var text_count = jQuery('.cart-count-bubble span[aria-hidden="true"]').text();
if(text_count != ""){
jQuery('span#cart-count').text('(' + text_count + ')');
}



jQuery(document).on('click', 'span.open-next', function () {
  var $current = jQuery('.thumbnail-list__item.active');
  var $next = $current.next('.thumbnail-list__item');

  if ($next.length) {
    $current.removeClass('active');         // Remove from current
    $next.addClass('active');               // Add to next
    $next.find('button.thumbnail').trigger('click');
  } else {
    // Loop to first
    var $first = jQuery('.thumbnail-list__item').first();
    $current.removeClass('active');
    $first.addClass('active');
    $first.find('button.thumbnail').trigger('click');
  }
});

// PREV button
jQuery(document).on('click', 'span.open-prev', function () {
  var $current = jQuery('.thumbnail-list__item.active');
  var $prev = $current.prev('.thumbnail-list__item');

  if ($prev.length) {
    $current.removeClass('active');         // Remove from current
    $prev.addClass('active');               // Add to prev
    $prev.find('button.thumbnail').trigger('click');
  } else {
    // Loop to last
    var $last = jQuery('.thumbnail-list__item').last();
    $current.removeClass('active');
    $last.addClass('active');
    $last.find('button.thumbnail').trigger('click');
  }
});

jQuery(document).on('click', '.thumbnail', function () {
  var $parent = jQuery(this).closest('.thumbnail-list__item');
  $parent.addClass('active').siblings().removeClass('active');
});








  // jQuery(document).on('click', 'span.open-prev', function(){
  //     jQuery('.main_slide_thum[aria-current="true"]').prev("li").find("button").click();
  // })
  // jQuery(document).on('click', 'span.open-next', function(){
  //     jQuery('.main_slide_thum[aria-current="true"]').next("li").find("button").click();
  // })

//   jQuery(".tabbing-section-brand-story .rich-text__heading strong:first-child").addClass("active-add");

// $('.extra-class .slick-slider').on('afterChange', function(event, slick, currentSlide){
//     let activeSlide = $('.extra-class .slick-slide').eq(currentSlide);
//     console.log(activeSlide.find("h3").text());

//       if(activeSlide.prev(".slick-slide").find("h3").text().trim() == "Our Ingredients & Process"){

//  jQuery(".tabbing-section-brand-story .rich-text__heading strong").removeClass("active-add");
//  jQuery(".tabbing-section-brand-story .rich-text__heading strong:nth-child(2)").addClass("active-add");   
   
//      }else if(activeSlide.prev(".slick-slide").find("h3").text().trim() == "Our Fragrance Experience"){

//  jQuery(".tabbing-section-brand-story .rich-text__heading strong").removeClass("active-add");
//  jQuery(".tabbing-section-brand-story .rich-text__heading strong:nth-child(3)").addClass("active-add"); 
           
//      }else{
//          jQuery(".tabbing-section-brand-story .rich-text__heading strong").removeClass("active-add");
//  jQuery(".tabbing-section-brand-story .rich-text__heading strong:first-child").addClass("active-add");
//      }
// });


});


// jQuery(document).on('click', '.open-next', function(){
// 	if(jQuery('.thumbnail-list__item .thumbnail[aria-current="true"]').parents(".thumbnail-list__item").next(".thumbnail-list__item").length != 0){
// 		jQuery('.thumbnail-list__item .thumbnail[aria-current="true"]').parents(".thumbnail-list__item").next(".thumbnail-list__item").find("button").click();
// 	}else{
// 		jQuery('.thumbnail-list .thumbnail-list__item:nth-child(1)').find("button").click();
// 	}
// });

// jQuery(document).on('click', '.open-prev', function(){
// 	if(jQuery('.thumbnail-list__item .thumbnail[aria-current="true"]').parents(".thumbnail-list__item").prev(".thumbnail-list__item").length != 0){
// 		jQuery('.thumbnail-list__item .thumbnail[aria-current="true"]').parents(".thumbnail-list__item").prev(".thumbnail-list__item").find("button").click();
// 	}else{
// 		jQuery('.thumbnail-list .thumbnail-list__item:last-child').find("button").click();
// 	}
// });

// jQuery(document).on('click', '.thumbnail-list__item button', function(){
//   jQuery(".thumbnail-list__item").removeAttr("aria-current");
//   jQuery(this).parents(".thumbnail-list__item").attr("aria-current", "true");
// });